import React from "react";
import { useTranslation } from "react-i18next";
import { useConsent } from "../context/ConsentContext";
import { loadStripe } from "@stripe/stripe-js";
import { getAuth } from "firebase/auth";
import { useState } from "react";



const stripePromise = loadStripe("pk_live_51RMyExDslyGxJKJWW63UbeRohxi3GIR9tAYLFdCLBj9EHm7L8ethrB8GOnd7tuf8cEpDzOKWgF7gfVgStjorTqPe00PBppR1ew"); // Tvoj **public** Stripe ključ


const Pricing = () => {
  const { t } = useTranslation();
  const { consent } = useConsent();
  const [showConsentPrompt, setShowConsentPrompt] = useState(false);


  const plans = [
    // {
    //   key: "test", // ⬅️ dodato
    //   name: t("pricing.test"),
    //   amount: "$1",
    //   period: "/month",
    //   features: [
    //     t("pricing.test_1"),
    //     t("pricing.test_2"),
    //     t("pricing.test_3"),
    //     t("pricing.test_4")
    //   ],
    //   cta: t("pricing.cta_start"),
    // },
    {
      key: "basic", // ⬅️ dodato
      name: t("pricing.basic"),
      amount: "$19",
      period: "/month",
      features: [
        t("pricing.basic_1"),
        t("pricing.basic_2"),
        t("pricing.basic_3"),
        t("pricing.basic_4")
      ],
      cta: t("pricing.cta_start"),
    },
    {
      key: "pro",
      name: t("pricing.pro"),
      amount: "$49",
      period: "/month",
      features: [
        t("pricing.pro_1"),
        t("pricing.pro_2"),
        t("pricing.pro_3"),
        t("pricing.pro_4")
      ],
      cta: t("pricing.cta_try"),
      highlight: true
    },
    {
      key: "studio",
      name: t("pricing.studio"),
      amount: "$99",
      period: "/month",
      features: [
        t("pricing.studio_1"),
        t("pricing.studio_2"),
        t("pricing.studio_3"),
        t("pricing.studio_4")
      ],
      cta: t("pricing.cta_popular"),
    },
    {
      key: "enterprise",
      name: t("pricing.enterprise"),
      amount: t("pricing.on_request"),
      period: "",
      features: [
        t("pricing.ent_1"),
        t("pricing.ent_2"),
        t("pricing.ent_3"),
        t("pricing.ent_4")
      ],
      cta: t("pricing.cta_contact"),
    }
  ];

  const handleSubscribe = async (planKey) => {
    
   
    if (!consent) {
  setShowConsentPrompt(true);
  return;
}


  const auth = getAuth();
  const user = auth.currentUser;

  if (!user?.uid) {
    setShowLoginPrompt(true);
    return;
  }
  
    try {
      const res = await fetch("https://modularobjects.com/checkout/api/payment/create-subscription-session", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          plan: planKey,
          userId: user.uid // ✔️ šalješ backendu za povezivanje
        })
      });
  
      const data = await res.json();
  
      if (data.id) {
        const stripe = await stripePromise;
        await stripe.redirectToCheckout({ sessionId: data.id });
      } else {
        alert("❌ Greška: Stripe sesija nije dobijena.");
      }
    } catch (err) {
      console.error("❌ Greška pri pretplati:", err);
      alert("Došlo je do greške prilikom pokretanja pretplate.");
    }
  };
  
  const [showLoginPrompt, setShowLoginPrompt] = useState(false);
  

  return (
    <div className="p-8 max-w-7xl mx-auto space-y-12">
      <section className="text-center">
        <h1 className="text-3xl font-bold text-primary-light dark:text-primary-dark mb-4">
          {t("pricing.choose_plan")}
        </h1>
        <p className="text-lg text-text-light dark:text-text-dark">
          {t("pricing.pricing_subtext")}
        </p>
      </section>

      <section className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">
        {plans.map((plan) => (
          <div
            key={plan.name}
            className={`rounded-lg shadow-md p-6 border dark:border-gray-800 transition hover:shadow-xl bg-white dark:bg-neutral-800 ${
              plan.highlight ? "border-2 border-primary-light dark:border-primary-dark" : ""
            }`}
          >
            <h3 className="text-2xl font-bold text-primary-light dark:text-primary-dark mb-2">
              {plan.name}
            </h3>
            <p className="text-3xl font-bold mb-4 text-primary-light dark:text-primary-dark">
              {plan.amount}
              <span className="text-base align-bottom text-text-light dark:text-text-dark">{plan.period}</span>
            </p>
            <ul className="space-y-2 text-text-light dark:text-text-dark mb-6">
              {plan.features.map((f, i) => (
                <li key={i}>• {f}</li>
              ))}
            </ul>
            {plan.key !== "enterprise" ? (
  <button
    onClick={() => handleSubscribe(plan.key)}
    className="btn-primary w-full"
  >
    {plan.cta}
  </button>
) : (
  <a
    href="mailto:info@modularobjects.com"
    className="btn-primary w-full text-center block"
  >
    {plan.cta}
  </a>
)}

          </div>
        ))}
      </section>

      {showLoginPrompt && (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
    <div className="bg-white dark:bg-neutral-800 rounded-xl p-6 shadow-xl max-w-sm w-full text-center">
      <h2 className="text-xl font-semibold text-primary-light dark:text-primary-dark mb-4">
        {t("pricing.login_required_title")}
      </h2>
      <p className="text-sm text-text-light dark:text-text-dark mb-6">
        {t("pricing.login_required_message")}
      </p>
      <div className="flex justify-center gap-4">
        <a href="/login" className="btn-primary">
          {t("pricing.login_button")}
        </a>
        <button
          onClick={() => setShowLoginPrompt(false)}
          className="px-4 py-2 rounded bg-gray-300 dark:bg-gray-600 text-sm"
        >
          {t("pricing.close_button")}
        </button>
      </div>
    </div>
  </div>
)}

{showConsentPrompt && (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
    <div className="bg-white dark:bg-neutral-800 rounded-xl p-6 shadow-xl max-w-sm w-full text-center">
      <h2 className="text-xl font-semibold text-primary-light dark:text-primary-dark mb-4">
        {t("cookie.cookies_required_title") || "Cookies Required"}
      </h2>
      <p className="text-sm text-text-light dark:text-text-dark mb-6">
        {t("cookie.cookies_required_message") || "Please accept cookies to continue using this feature."}
      </p>
      <div className="flex justify-center">
        <button
          onClick={() => setShowConsentPrompt(false)}
          className="btn-primary"
        >
          {t("pricing.close_button") || "Close"}
        </button>
      </div>
    </div>
  </div>
)}


    </div>
  );
};

export default Pricing;